.ky{white-space:nowrap;}